import type { NodeType } from '@tiptap/pm/model';
import getZwspPlugin, { ZWSP } from '../../../plugins/getZwspPlugin';

/**
 * Zero-width space character used to ensure empty captions have a cursor target.
 * Re-exported for backwards compatibility with any existing consumers.
 */
export { ZWSP };

/**
 * Plugin that maintains a zero-width space in empty captions for Safari cursor positioning.
 *
 * Behavior:
 * - When a caption becomes empty, inserts a ZWSP to give the cursor something to anchor to
 * - When real text is added alongside ZWSP, strips the ZWSP characters
 * - Backspace on empty caption (ZWSP only) deletes the entire caption node
 * - Handles multiple captions in a document correctly
 * - Works with undo/redo (appendTransaction respects history)
 */
const getCaptionZwspPlugin = (captionType: NodeType) =>
  getZwspPlugin(captionType, { deleteNodeOnBackspace: true, pluginKey: 'captionZwsp' });

export default getCaptionZwspPlugin;
